// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zFML","toggleWrap":"styles_toggleWrap__2Q_mC","content":"styles_content__3YyKM","selectAreaCode":"styles_selectAreaCode__1yY45"};